import { render, staticRenderFns } from "./title-divider.vue?vue&type=template&id=12f91831&scoped=true"
import script from "./title-divider.vue?vue&type=script&setup=true&lang=js"
export * from "./title-divider.vue?vue&type=script&setup=true&lang=js"
import style0 from "./title-divider.vue?vue&type=style&index=0&id=12f91831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f91831",
  null
  
)

export default component.exports